import Card from '@klv/molecules/card';
import { ModulesGrid } from '@klv/utils/grid';
import { generateClassName, getColorScheme } from '@klv/shared/utils/functions';

import * as s from './styles/cards.module.css';

import type { ICards } from './types';
import type { TBaseProps } from '@klv/shared/types';

const Cards = ({
  cards, className, headline = '', subhead = '', variant = 'light', ...props
}: ICards & TBaseProps<'div'>) => (
    <div
      {...props}
      className={generateClassName([s.cards, className])}
      data-color-scheme={getColorScheme(variant)}
  >
    <ModulesGrid className={generateClassName([s.grid, 'defaultPaddingTop', 'defaultPaddingBottom'])}>
      <div className={s.headlineGroup}>
        {headline && (
          <div className={generateClassName([s.headline, 'h3'])}>
            {headline}
          </div>
        )}
        <div className="p2">
          {subhead}
        </div>
      </div>
      <div className={s.cardGroup}>
        {(cards.length > 0) && cards.map((singleCard) => {
          const nestedCard = singleCard.card;

          return (
            <Card
              className={s.card}
              key={JSON.stringify(nestedCard)}
              bodyCopy={nestedCard.bodyCopy}
              buttons={nestedCard?.buttons}
              icon={nestedCard?.icon}
              variant={variant}
              title={nestedCard.title}
            />
          );
        })}
      </div>
    </ModulesGrid>
  </div>
);

export default Cards;
